module.exports = __webpack_public_path__ + "img/navbar-close.da2e66f8.svg";